import React from 'react'

const ThirdPanel = props => (
    <svg viewBox="0 0 455.431 455.431" {...props}>
        <path
            d="M405.493 412.764c-69.689 56.889-287.289 56.889-355.556 0-69.689-56.889-62.578-300.089 0-364.089s292.978-64 355.556 0 69.689 307.201 0 364.089z"
            fill="#5ca4da"
        />
        <path
            d="M229.138 313.209c-62.578 49.778-132.267 75.378-197.689 76.8-48.356-82.489-38.4-283.022 18.489-341.333 51.2-52.622 211.911-62.578 304.356-29.867 22.755 93.867-24.178 213.333-125.156 294.4z"
            fill="#6dafe0"
        />
        <path
            d="M145.227 141.12V88.498h167.822v42.667l-56.889 64c21.333 4.267 38.4 12.8 51.2 28.444 11.378 14.222 18.489 31.289 18.489 51.2 0 28.444-9.956 51.2-29.867 68.267s-44.089 24.178-75.378 24.178c-29.867 0-61.156-11.378-92.444-32.711l25.6-48.356c25.6 18.489 49.778 27.022 69.689 27.022 12.8 0 22.756-2.844 29.867-8.533 8.533-5.689 11.378-14.222 11.378-25.6s-4.267-19.911-14.222-27.022c-8.533-7.111-21.333-9.956-38.4-9.956-8.533 0-21.333 2.844-36.978 7.111v-45.511l52.622-62.578h-82.489z"
            fill="#fff"
        />
    </svg>
)

export default ThirdPanel
